

import VueDragResize from 'vue-drag-resize'
import OrdersBoxMobile from './orders-box-mobile.vue';
export default {
  name: "OrdersBox",
  components: {
    VueDragResize,
    OrdersBoxMobile
  },
  props: {
    value: {
      type: Boolean,
      required: false
    },
  },
  mounted() {
    let t = this;
  },
  created() {
    let t = this;

    let rect = localStorage['rect_orders_box'] || '{}';
    rect = JSON.parse(rect);
    t.rect.x = rect.x || 150;
    t.rect.y = rect.y || 80;
    t.rect.scale = rect.scale || 100;
  },
  activated: function (el) {
  },
  deactivated() {
  },
  methods: {
    close() {
      this.show = false;
      this.$emit('input', false);
    },

    onDragStop(o) {
      this.rect.x = o.left;
      this.rect.y = o.top;
      localStorage['rect_orders_box'] = JSON.stringify(this.rect);
    },

    onScaleChange() {
      localStorage['rect_orders_box'] = JSON.stringify(this.rect);
    },
  },
  data() {
    return {
      rect: {
        x: 0,
        y: 0,
        scale: 100
      },
      isDraggable: false,
      show: true,
    };
  },
  computed: {
    filteredLogs() {
      let t = this;
      return t.list.log.filter((item) => {
        if (item.type == t.type || t.type == 4) {
          return true;
        }
        return false;
      });
    },
  }
};
